import {
  AgentSetupBlock,
  type AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';
import { FEATURE_TO_TITLE } from '../../constants';

import { getDocsLink } from '@cast/utils';

import { ExternalLink } from '@cast/design-system';

type SetupProps = Pick<
  AgentSetupBlockProps,
  | 'checked'
  | 'onChange'
  | 'hasBeenInstalled'
  | 'showCheckbox'
  | 'readonly'
  | 'readonlyTooltip'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.nvidiaGpuPlugin;

export const AgentNvidiaDevicePluginSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description={
        <>
          Required to run GPU enabled containers in your cluster.{' '}
          <ExternalLink link={getDocsLink('docs_gpu_config')}>
            Learn more
          </ExternalLink>
        </>
      }
      isNestedBlock
      labelChip={<FeatureLabel />}
      testId="install-nvidia"
      {...props}
    />
  );
};

export const AgentNvidiaDevicePluginComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      testId="agent-install-nvidia-complete"
      isNestedBlock
      checked={checked}
    />
  );
};
